var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLineRightS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ArrowLineRight-s"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.07459 15.9419C6.80847 15.6979 6.80847 15.3021 7.07459 15.0581L11.5625 10.9419C11.8286 10.6979 11.8286 10.3021 11.5625 10.0581L7.07459 5.94194C6.80847 5.69786 6.80847 5.30214 7.07459 5.05806C7.34072 4.81398 7.77219 4.81398 8.03831 5.05806L12.5262 9.17418C13.3246 9.90641 13.3246 11.0936 12.5262 11.8258L8.03831 15.9419C7.77219 16.186 7.34072 16.186 7.07459 15.9419Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLineRightS);
export default __webpack_public_path__ + "static/media/ArrowLineRight-s.2682a0bb0705da4d61b972393d7c2ac0.svg";
export { ForwardRef as ReactComponent };